import Item from '../item';

const Reply = props => (
	<li className="FeedListItem FeedListItem--reply">
		<Item {...props} />
	</li>
);

export default Reply;
